import { useGT } from 'gt-react';

export function NeedMixedCell() {
  const gt = useGT();
  return (
    <span className="text-xs italic text-muted-foreground">
      {gt('Mixed', {
        context: 'buyer board need row, SO lines disagree on this value',
      })}
    </span>
  );
}
